const routeFeatureSets = {
    createOrganization: ['organizations'],
    editOrganization: ['organizations'],
    drawActuators: ['actuators', 'circuits'],
    drawAdmin: ['admin'],
    drawAlarms: ['alarms'],
    drawBulkCreateAlarms: ['alarms'],
    drawBulkDeleteAlarms: ['alarms'],
    drawBulkEditAlarms: ['alarms'],
    drawCreateAlarm: ['alarms'],
    drawApiKeys: ['apiKeys', 'users'],
    drawNewApiKey: ['apiKeys', 'users'],
    drawEditApiKey: ['apiKeys', 'users'],
    drawChat: ['chat'],
    drawCircuit: ['circuits', 'indicators'],
    drawCircuitTags: ['circuitTags'],
    drawNewCircuitType: ['circuitTags'],
    drawCircuits: ['circuits'],
    drawCompanies: ['companies'],
    drawNewCompany: ['companies'],
    drawEditCompany: ['companies'],
    drawContract: ['contracts'],
    drawDevices: ['devices'],
    drawEtls: ['etls'],
    drawNewEtl: ['etls'],
    drawEditEtl: ['etls', 'indicators'],
    drawEvents: ['events'],
    drawEditAlarm: ['alarms'],
    drawFolder: ['folders', 'indicators'],
    drawGroups: ['groups'],
    drawNewGroup: ['groups', 'users'],
    drawEditGroup: ['groups', 'users'],
    drawHolidays: ['holidays'],
    drawIndicator: ['alarms', 'indicators', 'objectives'],
    drawIndicators: ['indicators', 'objectives'],
    drawEditIndicator: ['indicators'],
    drawNewIndicator: ['indicators'],
    drawNewReport: ['reports'],
    drawNewScheduledReport: ['scheduledReports'],
    drawEditScheduledReport: ['scheduledReports'],
    drawScheduledReports: ['scheduledReports'],
    drawIntegration: ['integrations'],
    drawIntegrationLicense: ['integrationLicenses', 'integrationConfigurations', 'integrationPartners', 'integrations'],
    drawLeads: ['leads'],
    drawMarkers: ['markers'],
    drawEditMarker: ['markers', 'indicators'],
    drawNotifications: ['notifications'],
    drawOrganization: ['organizations', 'organizationLogs', 'sites', 'apiRequests', 'admin', 'etls', 'holidays', 'folders'],
    drawReadings: ['readings'],
    drawReports: ['reports', 'scheduledReports'],
    drawRootObject: ['rootObjects', 'circuits', 'companies', 'folders', 'indicators', 'seus', 'tenantInvoices', 'tenants', 'utilities', 'zones'],
    drawSeu: ['seus', 'objectives', 'markers', 'opportunities'],
    drawShowAlarm: ['alarms'],
    drawSite: ['zones', 'circuits', 'folders', 'indicators', 'objectives', 'opportunities', 'reports', 'scheduledReports', 'siteDocuments'],
    drawSiteTags: ['siteTags'],
    drawNewSiteTag: ['siteTags'],
    drawEditSiteTag: ['siteTags'],
    drawTariffs: ['tariffs', 'tars'],
    drawTenant: ['allocations', 'companies', 'tenantInvoices', 'tenants'],
    drawTenants: ['companies', 'tenantInvoices', 'tenants'],
    drawUserProfile: ['users'],
    drawUsers: ['users'],
    drawNewUser: ['users'],
    drawEditUser: ['users', 'groups'],
    drawUtility: ['utilities', 'invoices'],
    drawWiseStore: ['integrationPartners'],
    drawZone: ['zones', 'circuits', 'folders', 'indicators', 'objectives', 'opportunities', 'reports', 'scheduledReports', 'siteDocuments'],
    drawZoneAttributes: ['zoneAttributes'],
    drawNewZoneAttribute: ['zoneAttributes'],
    drawEditZoneAttribute: ['zoneAttributes']
};

const baseBlockingCollectionNames = [
    'alarms',
    'objectives',
    'opportunities',
    'sitePackages',
    'zone_attribute_values',
    'zone_attributes'
];

const routeBlockingCollectionNames = {
    drawActuators: ['actuators'],
    drawAlarms: ['alarms'],
    drawApiKeys: ['groups', 'users'],
    drawCircuitTags: ['circuitTags'],
    drawCompanies: ['companies'],
    drawDevices: ['devices'],
    drawEtls: ['etls'],
    drawGroups: ['groups', 'users'],
    drawHolidays: ['holidays'],
    drawIndicator: ['markers'],
    drawIntegration: ['integrationConfigurations', 'integrations'],
    drawIntegrationLicense: ['integrationConfigurations', 'integrationLicenseLogs', 'integrationLicenses', 'integrationPartners', 'integrations'],
    drawLeads: ['leads'],
    drawMarkers: ['markers'],
    drawOrganization: ['apiRequests', 'organizationLogs'],
    drawReports: ['reports', 'scheduledReports', 'users'],
    drawSiteTags: ['siteTags'],
    drawTariffs: ['tariffs', 'tars'],
    drawTenant: ['allocations', 'companies', 'tenantInvoices', 'tenants'],
    drawTenants: ['companies', 'tenantInvoices', 'tenants'],
    drawUsers: ['groups', 'users'],
    drawWiseStore: ['integrationLicenses'],
    drawZoneAttributes: ['zone_attribute_values', 'zone_attributes']
};

const routeViewBlockingCollectionNames = {
    drawSite: {
        permissions: ['groups', 'users'],
        reports: ['reports', 'users'],
        scheduled_reports: ['scheduledReports', 'users'],
        site_documents: ['siteDocuments']
    },
    drawUtility: {
        invoices: ['invoices']
    },
    drawZone: {
        permissions: ['groups', 'users'],
        reports: ['reports', 'users'],
        scheduled_reports: ['scheduledReports', 'users'],
        site_documents: ['siteDocuments']
    }
};

const resolveRouteName = (parts) => {
    const section = parts[0] || 'home';

    const routeNameBySection = {
        actuators: 'drawActuators',
        admin: 'drawAdmin',
        alarms: 'drawAlarms',
        api_keys: 'drawApiKeys',
        design_system: 'drawDesignSystem',
        site_tags: 'drawSiteTags',
        chat: 'drawChat',
        circuit_types: 'drawCircuitTags',
        companies: 'drawCompanies',
        contracts: 'drawContract',
        custom_dashboard: 'drawCustomDashboard',
        dashboard: 'drawDashboard',
        devices: 'drawDevices',
        events: 'drawEvents',
        etls: 'drawEtls',
        folders: 'drawFolder',
        groups: 'drawGroups',
        holidays: 'drawHolidays',
        home: 'drawDashboard',
        integrations: 'drawIntegration',
        integration_licenses: 'drawIntegrationLicense',
        leads: 'drawLeads',
        login: 'drawLogin',
        map: 'drawMap',
        markers: 'drawMarkers',
        notifications: 'drawNotifications',
        readings: 'drawReadings',
        reports: 'drawReports',
        signup: 'drawSignup',
        tariffs: 'drawTariffs',
        tree: 'drawTree',
        user_profile: 'drawUserProfile',
        'wise-store': 'drawWiseStore',
        zone_attributes: 'drawZoneAttributes'
    };

    if (section === 'all_tenants') {
        return parts[1] ? 'drawTenant' : 'drawTenants';
    }

    if (section === 'circuits') {
        return parts[1] ? 'drawCircuit' : 'drawCircuits';
    }

    if (section === 'indicators') {
        if (parts[1] === 'new') {
            return 'drawNewIndicator';
        }
        if (parts[2] === 'edit') {
            return 'drawEditIndicator';
        }
        return parts[1] ? 'drawIndicator' : 'drawIndicators';
    }

    if (section === 'organizations') {
        if (parts[1] === 'create') {
            return 'createOrganization';
        }

        if (parts[2] === 'edit') {
            return 'editOrganization';
        }

        return 'drawOrganization';
    }

    if (section === 'reports') {
        if (parts[1] === 'new') {
            return 'drawNewReport';
        }
        return 'drawReports';
    }

    if (section === 'scheduled_reports') {
        if (parts[1] === 'new') {
            return 'drawNewScheduledReport';
        }
        if (parts[2] === 'edit') {
            return 'drawEditScheduledReport';
        }
        return 'drawScheduledReports';
    }

    if (section === 'markers') {
        if (parts[2] === 'edit') {
            return 'drawEditMarker';
        }
        return 'drawMarkers';
    }

    if (section === 'etls') {
        if (parts[1] === 'new') {
            return 'drawNewEtl';
        }
        if (parts[2] === 'edit') {
            return 'drawEditEtl';
        }
        return 'drawEtls';
    }

    if (section === 'companies') {
        if (parts[1] === 'new') {
            return 'drawNewCompany';
        }
        if (parts[2] === 'edit') {
            return 'drawEditCompany';
        }
        return 'drawCompanies';
    }

    if (section === 'api_keys') {
        if (parts[1] === 'new') {
            return 'drawNewApiKey';
        }
        if (parts[2] === 'edit') {
            return 'drawEditApiKey';
        }
        return 'drawApiKeys';
    }

    if (section === 'site_tags') {
        if (parts[1] === 'new') {
            return 'drawNewSiteTag';
        }
        if (parts[2] === 'edit') {
            return 'drawEditSiteTag';
        }
        return 'drawSiteTags';
    }

    if (section === 'circuit_types') {
        if (parts[1] === 'new') {
            return 'drawNewCircuitType';
        }
        return 'drawCircuitTags';
    }

    if (section === 'groups') {
        if (parts[1] === 'new') {
            return 'drawNewGroup';
        }
        if (parts[2] === 'edit') {
            return 'drawEditGroup';
        }
        return 'drawGroups';
    }

    if (section === 'zone_attributes') {
        if (parts[1] === 'new') {
            return 'drawNewZoneAttribute';
        }
        if (parts[2] === 'edit') {
            return 'drawEditZoneAttribute';
        }
        return 'drawZoneAttributes';
    }

    if (section === 'reset_password') {
        return 'drawResetPassword';
    }

    if (section === 'root_objects') {
        return 'drawRootObject';
    }

    if (section === 'seus') {
        return 'drawSeu';
    }

    if (section === 'sites') {
        return 'drawSite';
    }

    if (section === 'tenants') {
        return parts[1] ? 'drawTenant' : 'drawTenants';
    }

    if (section === 'users') {
        if (parts[1] === 'new') {
            return 'drawNewUser';
        }
        if (parts[2] === 'edit') {
            return 'drawEditUser';
        }
        return 'drawUsers';
    }

    if (section === 'utilities') {
        return 'drawUtility';
    }

    if (section === 'zones') {
        return 'drawZone';
    }

    return routeNameBySection[section] || 'drawDefault';
};

const getRouteContextFromFragment = (fragment = 'home') => {
    const normalizedFragment = (fragment || 'home').split('?')[0];
    const parts = normalizedFragment.split('/').filter(Boolean);
    const routeName = resolveRouteName(parts);

    return {
        fragment: normalizedFragment,
        parts,
        routeName,
        section: parts[0] || 'home',
        view: parts[2] || null
    };
};

const getBlockingCollectionNamesForRouteContext = (routeContext) => {
    const blockingCollectionNames = new Set(baseBlockingCollectionNames);

    (routeBlockingCollectionNames[routeContext.routeName] || []).forEach(name => blockingCollectionNames.add(name));

    if (routeContext.routeName === 'drawIndicator' && routeContext.view === 'objectives') {
        blockingCollectionNames.add('objectives');
    }

    const routeViewBlockingNames = routeViewBlockingCollectionNames[routeContext.routeName] || {};
    (routeViewBlockingNames[routeContext.view] || []).forEach(name => blockingCollectionNames.add(name));

    return [...blockingCollectionNames];
};

const shouldWaitForDashboardEvents = (routeContext) => {
    return routeContext.routeName === 'drawDashboard' || (['drawSite', 'drawZone'].includes(routeContext.routeName) && (!routeContext.view || routeContext.view === 'dashboard'));
};

module.exports = {
    getBlockingCollectionNamesForRouteContext,
    getRouteContextFromFragment,
    routeFeatureSets,
    shouldWaitForDashboardEvents
};
